import { GetUnstableData } from '../graphql/docs'
import StepForm from '../components/StepForm'
import Segment from '../components/Segment'
import { useQuery } from '../lib/useQuery'

export default function Landing() {
	const { data: onboardingData } = useQuery(GetUnstableData, { context: 'onboarding' })

	return (
		<StepForm>
			<Segment name="my-info" {...onboardingData} />
		</StepForm>
	)
}
